export enum EtapaAuxiliarGerenciarEmplacamentosEnum {
  CONSULTAR = "consultar",
  FINALIZADO = "finalizado",
  INDEFERIDO = "indeferido",
}
